module.exports = __webpack_public_path__ + "img/password.6b4c0d25.svg";